import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconPaletts = createIcon({
  displayName: 'IconPaletts',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M2 4H22V6H2V4ZM22 9H2V11H22V9ZM2 13H22V15H2V13ZM2 18H22V20H2V18Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
